import React from "react";
import { Route, Redirect } from "react-router-dom";

const publicRoute = ({ component: Component, auth, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      // auth.isAuthenticated === true
      !localStorage.AuthUserKey ? (
        <Component {...props} />
      ) : (
        <Redirect to="/RestaurantsGroups" />
      )
    }
  />
);

export default publicRoute;
